import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import SideNav from '../navigation/SideNav';
import bannerLogo from '../resources/images/logos/bannerLogo.svg';

import { PrivateLayoutProvider, usePrivateLayout } from './PrivateLayoutContext';

import '../resources/global.css';

const PrivateLayoutContent = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const { bannerChildren } = usePrivateLayout();

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        overflow: 'hidden',
        backgroundColor: 'var(--ft-white)'
      }}>
      <SideNav user={user} />

      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          height: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',

          // Mobile SideNav header is fixed at 72px
          pt: {
            xs: '72px',
            md: 0
          }
        }}>
        {/* Banner */}
        {bannerChildren && (
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: {
                xs: '192px',
                sm: '200px',
                md: '220px',
                lg: '240px'
              },
              backgroundColor: 'var(--ft-dark)',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              px: {
                xs: '16px',
                sm: '24px',
                md: '32px'
              },
              py: {
                xs: '32px',
                sm: '36px',
                md: '40px'
              },
              gap: {
                xs: '24px',
                sm: '28px',
                md: '32px'
              },
              mb: '40px'
            }}>
            {/* Banner content */}
            <Box
              sx={{
                position: 'relative',
                zIndex: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                flexShrink: 0
              }}>
              {bannerChildren}
            </Box>

            {/* Cropped banner logo */}
            <Box
              component="img"
              src={bannerLogo}
              alt=""
              sx={{
                position: 'absolute',
                zIndex: 1,
                width: {
                  xs: '190px',
                  sm: '220px',
                  md: '250px',
                  lg: '280px'
                },
                height: {
                  xs: '190px',
                  sm: '220px',
                  md: '250px',
                  lg: '280px'
                },
                right: {
                  xs: '-24px',
                  sm: '-28px',
                  md: '-30px',
                  lg: '-32px'
                },
                bottom: {
                  xs: '-48px',
                  sm: '-56px',
                  md: '-64px',
                  lg: '-72px'
                },
                objectFit: 'contain'
              }}
            />
          </Box>
        )}

        {/* Page content */}
        <Box
          sx={{
            px: {
              xs: 2,
              md: 4
            },
            pt: bannerChildren
              ? 0
              : {
                  xs: 3,
                  md: 6
                },
            pb: 6
          }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

const PrivateLayout = ({ children }) => {
  return (
    <PrivateLayoutProvider>
      <PrivateLayoutContent>{children}</PrivateLayoutContent>
    </PrivateLayoutProvider>
  );
};

export default PrivateLayout;
